import { MAP_ROUTES } from '@/modules/map';
import { ASSET_ROUTES } from '@/modules/assets';
import { DASHBOARD_ROUTES } from '@/modules/dashboards';
import App from '@/App';
import { createBrowserRouter, Navigate } from 'react-router';
import { ConditionalApplicationLayout, PublicLayout, LoginPage } from '@/modules/application';
import { CONFIGURATION_ROUTES } from '@/modules/configuration';
import { LOCATION_ROUTES, GUEST_LOCATION_ROUTES } from '@/modules/locations';
import { EVENT_ROUTES } from '@/modules/events';
import { ErrorPage } from '@/modules/application/pages/ErrorPage';
import MobileLayout from '@/modules/mobile/layouts/MobileLayout';
import { MOBILE_ROUTES } from '@/modules/mobile/routes/mobile.routes';
import { BALANCE_ROUTES } from '@/modules/balances/routes/balance.routes';
import { TRANSACTION_ROUTES } from '@/modules/transactions/routes/transactions.routes';
import { GUEST_TRANSACTION_ROUTES } from '@/modules/transactions/routes/guest-transactions.routes';
import { MOVEMENT_ROUTES } from '@/modules/movements/routes/movement.routes';
import FirstAccessibleRoute from '@/components/permissions/FirstAccessibleRoute';
import { Routes } from './router-paths';

export const PUBLIC_PATHS = [Routes.LOGIN];

export const isPublicPath = (path: string) => {
  return PUBLIC_PATHS.includes(path as Routes);
};

export const isPrivatePath = (path: string) => {
  return !isPublicPath(path);
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        element: <PublicLayout />,
        errorElement: <ErrorPage />,
        children: [
          {
            path: 'login',
            element: <LoginPage />,
          },
        ],
      },
      {
        path: 'app',
        element: <ConditionalApplicationLayout />,
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            element: (
              <FirstAccessibleRoute
                parentPath="/app"
                routes={[
                  /**
                   * All App Module Routes go below
                   */
                  ...DASHBOARD_ROUTES,
                  ...MAP_ROUTES,
                  ...ASSET_ROUTES,
                  ...CONFIGURATION_ROUTES,
                  ...LOCATION_ROUTES,
                  ...GUEST_LOCATION_ROUTES,
                  ...EVENT_ROUTES,
                  ...BALANCE_ROUTES,
                  ...MOVEMENT_ROUTES,
                  ...TRANSACTION_ROUTES,
                  ...GUEST_TRANSACTION_ROUTES,
                ]}
              />
            ),
          },
          /**
           * All App Module Routes go below
           */
          ...DASHBOARD_ROUTES,
          ...MAP_ROUTES,
          ...ASSET_ROUTES,
          ...CONFIGURATION_ROUTES,
          ...LOCATION_ROUTES,
          ...GUEST_LOCATION_ROUTES,
          ...EVENT_ROUTES,
          ...BALANCE_ROUTES,
          ...MOVEMENT_ROUTES,
          ...TRANSACTION_ROUTES,
          ...GUEST_TRANSACTION_ROUTES,
        ],
      },
      {
        path: 'mobile',
        element: <MobileLayout />,
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            element: (
              <FirstAccessibleRoute
                parentPath="/mobile"
                routes={[
                  /**
                   * All Mobile Module Routes go below
                   */
                  ...MOBILE_ROUTES,
                ]}
              />
            ),
          },
          ...MOBILE_ROUTES,
        ],
      },
      {
        path: '*',

        element: <Navigate to="/app" replace />,
      },
    ],
  },
]);
